import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in
  const [users, setUsers] = useState([]);

  const refreshUsers = async () => {
    try {
      const { data } = await api.get("/users");
      setUsers(data);
    } catch (e) {}
  };

  useEffect(() => {
    const token = localStorage.getItem("c24_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data);
        refreshUsers();
      })
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password, captchaId, captchaAnswer) => {
    const body = { email, password };
    if (captchaId) { body.captcha_id = captchaId; body.captcha_answer = captchaAnswer; }
    const { data } = await api.post("/auth/login", body);
    localStorage.setItem("c24_token", data.access_token);
    setUser(data.user);
    refreshUsers();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("c24_token");
    setUser(false);
  };

  const isManager = user && (user.role === "super_admin" || user.role === "manager");

  return (
    <AuthCtx.Provider value={{ user, users, refreshUsers, login, logout, isManager }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function useUserMap() {
  const { users } = useAuth();
  const map = {};
  users.forEach((u) => (map[u.id] = u));
  return map;
}
